import { PLATFORM_SUPPORT_LANGUAGES } from '@bfe/by-shared-settings';

export const locales = PLATFORM_SUPPORT_LANGUAGES.map((locale) => locale.value);
